/*
 * The words for the state of an ARC header link (fundraising or volunteer).
 *
 * Shared by the ARC Builder's header card and the links sub-pages, so both
 * say it the same way. A saved, unpublished link reads "Saved, not
 * published" (organization-arc D3, P38). The backend derives NOT_SET and
 * stores DRAFT and PUBLISHED (backend D2); HIDDEN is never sent and reads as
 * its code.
 */

const LINK_STATUS: Record<string, string> = {
  NOT_SET: 'Not set',
  DRAFT: 'Saved, not published',
  PUBLISHED: 'Published',
};

/** The state of the link a header button opens, or the code for one not met. */
export function linkStatusLabel(status: string): string {
  return LINK_STATUS[status] ?? status;
}
